export const DEFAULT_LAT: number = -28.024;